import axios from "../../lib/axiosInstance";

// Finance dashboard — invoice analytics converted to USD on the backend.
// role=FREELANCER → engineer expenses, role=CLIENT → client revenue.
export const fetchInvoiceAnalytics = async ({ startDate, endDate, clientId, role } = {}) => {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (clientId) params.append("clientId", clientId);
  if (role) params.append("role", role);

  const url = `/analytics/invoices${params.toString() ? `?${params.toString()}` : ""}`;
  const response = await axios.get(url);
  return response.data;
};

// Monthly trend for a full calendar year (one line per client, respects filters).
export const fetchExpenseYearlyTrend = async ({ year, clientId, role } = {}) => {
  const params = new URLSearchParams();
  if (year) params.append("year", year);
  if (clientId) params.append("clientId", clientId);
  if (role) params.append("role", role);

  const url = `/analytics/invoices/yearlyTrend${params.toString() ? `?${params.toString()}` : ""}`;
  const response = await axios.get(url);
  return response.data;
};

// Monthly profit trend for a full calendar year (revenue − expenses).
export const fetchProfitTrend = async ({ year, clientId } = {}) => {
  const params = new URLSearchParams();
  if (year) params.append("year", year);
  if (clientId) params.append("clientId", clientId);

  const url = `/analytics/invoices/profitTrend${params.toString() ? `?${params.toString()}` : ""}`;
  const response = await axios.get(url);
  return response.data;
};
